"use client";

import CardGrid from "@/components/card-grid/card-grid";
import FilterBar from "@/components/filter-bar/filter-bar";
import { getCompanyContents } from "@/lib/api/company/content-grid";
import Image from "next/image";
import { useEffect, useState } from "react";
import useSWR from "swr";
import Loading from "../_partials/loading/loading";

const CompanyInfo = ({
	company,
	sorts,
	initialContents,
	initialPage,
	initialSort,
}: {
	company: any;
	sorts: any[];
	initialContents: any[];
	initialSort?: any;
	initialPage?: string;
}) => {
	const [page, setPage] = useState(initialPage ?? "1");
	const [selectedSort, setSelectedSort] = useState(initialSort ?? undefined);

	const {
		data: contents,
		mutate,
		isLoading,
	} = useSWR(
		["company-content", company?.id, selectedSort?.value, page],
		() => getCompanyContents(company?.id, page, selectedSort),
		{ fallbackData: initialContents, revalidateOnMount: false },
	);

	useEffect(() => {
		const query = new URLSearchParams();

		page && query.append("page", page);
		if (selectedSort) {
			query.append("sortBy", selectedSort.sortBy);
			query.append("direction", selectedSort.direction);
		}

		const qs = query.toString();
		const newUrl = qs
			? `${window.location.pathname}?${qs}`
			: window.location.pathname;

		window.history.replaceState(null, "", newUrl);

		mutate();
	}, [selectedSort, page, mutate]);

	return (
		<>
			<div className="w-full text-white py-6 px-6 lg:px-[80px] flex flex-col items-start">
				<div className="w-full py-6 rounded-lg shadow-lg flex flex-col justify-between lg:flex-row gap-4">
					{/* Movie Details */}
					<div className="lg:w-2/3 py-6 flex flex-col gap-4">
						<h1
							className="text-[35px] md:text-[48px] font-extraBold text-right"
							dir="ltr"
						>
							{company?.name}
						</h1>
					</div>
					<div className="w-full lg:w-[376px] flex justify-center flex-col items-center">
						<div className={"w-full lg:w-[376px]"}>
							{company?.logo?.code ? (
								<Image
									src={process.env.NEXT_PUBLIC_FILE_URL + company?.logo?.code}
									alt={company?.name}
									width={376}
									height={526}
									layout="responsive"
									className={"rounded-lg max-w-[376px] m-auto min-w-[376px]"}
								/>
							) : null}
						</div>
					</div>
				</div>
				<div className="w-full flex flex-wrap justify-between items-center py-8 gap-4">
					<h2 className="text-white text-[32px] font-bold">آثار</h2>
					<FilterBar
						showSearch={false}
						showSort={true}
						showGenre={false}
						initialSorts={sorts}
						setSort={setSelectedSort}
					/>
				</div>
				{isLoading ? (
					<div className="w-full h-full min-h-screen flex justify-center items-center">
						<Loading />
					</div>
				) : (
					<CardGrid data={contents} setPage={setPage} page={page} />
				)}
			</div>
		</>
	);
};

export default CompanyInfo;
